/**
 * Never edit this file manually. It is generated as part of the building process
 */
export const AppInfo = {
    name: 'medion-alditalk-client',
    appName: 'medion-alditalk-client',
    version: '2.17.1' ,
    defaultLocale: 'de',
    di18nMode: 'TRANSLATE',
    git: {
        shortHash: '623023d',
        hash: '623023dedff9cf5cbd2c71c4d0057ca37712282b',
        subject: 'Merge branch \'next\' into \'master\'',
        sanitizedSubject: 'Merge-branch-next-into-master',
        authoredOn: '1790775780',
        committedOn: '1790775780',
        branch: 'HEAD',
    }
};

